(() => {
  if (window.novaCatalogLoaded) return;
  window.novaCatalogLoaded = true;
  const initialize = (scope = document) => {
    scope.querySelectorAll('[data-catalog-section]').forEach((section) => {
      const controls = section.querySelector('[data-layout-controls]');
      const grid = section.querySelector('[data-product-grid]');
      if (!controls || !grid || controls.dataset.ready) return;
      controls.dataset.ready = 'true';
      controls.hidden = false;
      let columns = '2';
      try { columns = sessionStorage.getItem('nova-grid-columns') || '2'; } catch (_) { /* Storage can be unavailable. */ }
      const apply = (value) => {
        if (!['1', '2', '3'].includes(value)) value = '2';
        grid.classList.remove('cols-1', 'cols-2', 'cols-3');
        grid.classList.add('cols-' + value);
        controls.querySelectorAll('[data-grid-columns]').forEach((button) => {
          button.setAttribute('aria-pressed', String(button.dataset.gridColumns === value));
        });
        try { sessionStorage.setItem('nova-grid-columns', value); } catch (_) { /* Layout still works. */ }
      };
      apply(columns);
      controls.addEventListener('click', (event) => {
        const button = event.target.closest('[data-grid-columns]');
        if (button) apply(button.dataset.gridColumns);
      });
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialize());
  else initialize();
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
})();
